import Vue from "vue";
import Vuex from "vuex";

import i18n from "@chronos/promos-base/src/js/localization/Localization";

import loadKit from "@chronos/promos-base/src/config/loadKit";
import AuthService from "@chronos/frontend-base/src/libs/auth/AuthService";
import service_config from "@chronos/frontend-base/src/libs/auth/auth_service_config/projects/la/AuthServiceConfig";
import registerApiServices from "@/api/registerApiServices";
import api from "@chronos/frontend-base/src/libs/api/Api";
import store from "./store/index";
import App from "./App";
import TermsAcceptPlugin from "@chronos/frontend-base/src/plugins/terms/TermsAcceptPlugin";

Vue.use(Vuex);

loadKit();
Vue.config.productionTip = false;
Vue.prototype.$api = window.api = api;
Vue.prototype.$authService = AuthService;
window.authService = AuthService;

registerApiServices();

service_config.setDynamicParams({
  store,
  api,
});
AuthService.setConfig(service_config);

Vue.use(TermsAcceptPlugin, {
  store,
  is_site: false,
});

new Vue({
  components: { App },
  mounted() {
    const INIT_VUE_COMPONENTS = new Event("init_vue_components");
    document.dispatchEvent(INIT_VUE_COMPONENTS);
  },
  render: h => h(App),
  i18n,
  store,
}).$mount("#app");
